module.exports = __webpack_public_path__ + "static/img/jjytjjfa.0790e9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jjytjjfa.png
// module id = C3uu
// module chunks = 0